import axios from "axios";

const restClient = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API || "http://localhost:3000",
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

restClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token").replace(/"/g, "");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

restClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default restClient;
